import Vue from 'vue'

import Cookies from 'js-cookie'

import 'normalize.css/normalize.css' // a modern alternative to CSS resets

import 'echarts/theme/macarons'
import Element from 'element-ui'
import './styles/element-variables.scss'
import locale from 'element-ui/lib/locale/lang/zh-CN'

import '@/styles/index.scss' // global css
import '@/styles/common.scss' // common css
import App from './App'
import store from './store'
import router from './router'

import './icons' // icon
import './permission' // permission control
import './utils/error-log' // error log
import * as filters from './filters' // global filters

import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import VueClipboard from 'vue-clipboard2'

import Quill from "quill";
import { ImageDrop } from 'quill-image-drop-module';

window.Quill = Quill;
// require 不会被 webpack 提升，确保 window.Quill 在模块初始化前已设置
const ImageResize = require('quill-image-resize-module').default || require('quill-image-resize-module');

Quill.register("modules/imageResize", ImageResize);
Quill.register('modules/imageDrop', ImageDrop);

Vue.use(Viewer)

Vue.use(Element, {
  size: Cookies.get('size') || 'medium', // set element-ui default size
  locale
})

VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)

// register global utility filters
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
